import { formatMoney } from '@/utils'
import { PosModel } from '@/types'

/** The code a label carries: the first barcode, else the SKU (both scan, POS.md §18.8). */
export const codeOf = (p: PosModel.Product) => p.barcodes?.[0] || p.sku

/** What `product_label` / `shelf_label` place. */
export const labelData = (p: PosModel.Product, shop: string) => ({
  shop: { name: shop },
  options: { show_price: true },
  product: {
    name: p.name,
    price: formatMoney(p.price),
    unit: p.unit,
    compare_price: p.compare_price && p.compare_price > p.price ? formatMoney(p.compare_price) : '',
    barcode: codeOf(p),
  },
})
